// extracted by mini-css-extract-plugin
module.exports = {"quizDialog":"QuizModal_quizDialog__ZV9VJ","quizDialogContentWrapper":"QuizModal_quizDialogContentWrapper__PcNBH","content":"QuizModal_content__qJKOP"};